export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20flat%20lay%20of%20diverse%20fashion%20items%20sneakers%20hoodies%20caps%20bags%20and%20accessories%20arranged%20in%20organic%20flowing%20composition%20on%20warm%20sand%20colored%20textured%20surface%2C%20soft%20overhead%20natural%20light%2C%20minimal%20editorial%20style%20with%20generous%20negative%20space%2C%20high%20resolution%20commercial%20photography%20with%20harmonious%20earthy%20color%20palette&width=1600&height=900&seq=acbuy-hero-v2-bg&orientation=landscape"
          alt="ACBuy Spreadsheet Product Collection"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 animate-fade-in-up">
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight">
          ACBuy
          <br />
          <span className="font-normal">Spreadsheet</span>
          <br />
          <span className="text-3xl md:text-4xl lg:text-5xl font-normal opacity-90">Guide 2026</span>
        </h1>

        <p className="mt-6 text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          The ultimate acbuyspreadsheet resource — discover verified product categories, updated sourcing lists,
          and everything you need to navigate the ACBuy spreadsheet ecosystem efficiently.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#categories"
            className="bg-white text-foreground-900 font-medium text-sm px-8 py-3.5 rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2 shadow-lg"
          >
            Explore Categories
            <i className="ri-arrow-down-line text-sm"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="bg-primary-500 text-white font-medium text-sm px-8 py-3.5 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            buy it now
            <i className="ri-arrow-right-line text-sm"></i>
          </a>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}